import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faStar } from "@fortawesome/free-regular-svg-icons";
import { faStar as faRegStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { watchImmediate } from "@vueuse/core";
import { BButton } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { computed, ref, watch } from "vue";
import { useUserStore } from "@/stores/userStore";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FavoritesButton',
    props: {
        value: { type: Boolean, default: false },
        query: { default: undefined },
        tooltip: { default: "Show favorites" }
    },
    emits: ["change", "input"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faStar, faRegStar);
        const currentValue = computed(() => { var _a; return (_a = props.value) !== null && _a !== void 0 ? _a : false; });
        const toggle = ref(false);
        watchImmediate(() => currentValue.value, (val) => (toggle.value = val));
        const { isAnonymous } = storeToRefs(useUserStore());
        const FAVORITES = ["#favorites", "#favs", "#favourites"];
        const tooltipText = computed(() => {
            if (isAnonymous.value) {
                return "Log in to Favorite Tools";
            }
            else {
                if (toggle.value) {
                    return "Clear";
                }
                else {
                    return props.tooltip;
                }
            }
        });
        watch(() => props.query, () => {
            var _a;
            toggle.value = FAVORITES.includes((_a = props.query) !== null && _a !== void 0 ? _a : "");
        });
        function toggleFavorites() {
            toggle.value = !toggle.value;
            emit("input", toggle.value);
            emit("change", toggle.value);
        }
        return { __sfc: true, props, currentValue, toggle, emit, isAnonymous, FAVORITES, tooltipText, toggleFavorites, faStar, faRegStar, FontAwesomeIcon, BButton };
    }
});
